module.exports = __webpack_public_path__ + "media/images/fullscreen/login3-2dc7c71daf1977c794f253ea5b80a306.png";